import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserProfile } from '../models/user.models';
import { CryptoService } from './crypto.service';

@Injectable({ providedIn: 'root' })
export class DataService {
  private platformId = inject(PLATFORM_ID);
  private cryptoService = inject(CryptoService);

  private profileSubject = new BehaviorSubject<UserProfile | null>(this.loadStoredProfile());
  profile$: Observable<UserProfile | null> = this.profileSubject.asObservable();

  private loadStoredProfile(): UserProfile | null {
    try {
      if (typeof localStorage !== 'undefined') {
        const stored = localStorage.getItem('userProfile');
        if (stored) return JSON.parse(stored) as UserProfile;
      }
    } catch { /* SSR or parse error */ }
    return null;
  }

  setProfile(profile: UserProfile): void {
    if (profile.firstName && profile.lastName && !profile.fullName) {
      profile = { ...profile, fullName: `${profile.firstName} ${profile.lastName}` };
    }
    this.profileSubject.next(profile);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(
        'accessToken',
        this.cryptoService.doubleEncrypt(profile.token) as string
      );
      localStorage.setItem('userProfile', JSON.stringify(profile));
    }
  }

  getProfile(): UserProfile | null {
    return this.profileSubject.value;
  }

  clearProfile(): void {
    this.profileSubject.next(null);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userProfile');
    }
  }
}
